<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main custom-comment-modal">
      <div class="title-area" id="modal-moving">
        <h2>任意コメント設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="main-area">
        <span>{{ spaceObjName + '（id:' + form.spaceId + '）'}}</span>
        <div class="data-area">
          <textarea v-model="form.comment" rows="8" class="bs-input"></textarea>
        </div>
        <div class="errormessage-area">
          <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['comment'] }}</p>
        </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updateComment">更新</button>
        <button type="button" class="main_btn" @click="onCancel">閉じる</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetCustomCommentModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    focusedMenuSpace: Object
  },
  data () {
    return {
      modalShown: false,
      /** 選択空間 */
      selectedSpace: {},
      /** 選択空間オブジェクト名 */
      spaceObjName: '',
      form: {
        spaceId: '',
        comment: ''
      },
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** 任意コメントモーダル表示 */
    showModal: function () {
      this.clearData()
      this.modalShown = true
      if (this.focusedMenuSpace != null) {
        this.form.spaceId = this.focusedMenuSpace.id
      } else {
        this.form.spaceId = this.editCtrlSpaces[0].id
      }
      let obj = this.fileData.objectDataModelList.find(obj => obj.spaceId === this.form.spaceId)
      this.form.comment = obj.objCustomComment
      this.spaceObjName = obj.objName
    },
    /** モーダルキャンセル */
    onCancel: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** コメント更新 */
    updateComment: function () {
      let payload = this.form
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/space-comment/update', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.$emit('closeTreeContextModal')
          this.modalShown = false
          this.validateErrorMessages = {}
          this.$emit('setResponseData', response)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clearData: function () {
      this.form = {
        spaceId: '',
        comment: ''
      }
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-comment-modal{
  max-height: 100%;
  min-width: 750px;
  max-width: 800px;
}
.main-area {
  max-height: 680px;
  padding-top: 20px;
}
.data-area{
  min-height: 150px;
  margin: 20px auto;
  textarea{
    width: 60%;
  }
}
.errormessage-area{
  text-align: left;
  padding: 20px 140px;
}
.error_message {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetCustomCommentModal.vue